/* eslint-disable eqeqeq */
import AdminLayout from "components/layouts/AdminLayout";
import "./Import.scss";
import { Button, Spin, Collapse } from "antd";
import Table, { ITable } from "../../components/shared/table/Table";
import Modal from "antd/lib/modal/Modal";
import { useState, useEffect } from "react";
import FileUploader from "components/shared/fileManager/FileUploader";
import { FaArrowLeft } from "react-icons/fa";
import AdministrationImportServices from "services/services/AdministrationImportServices";
import { useNavigate } from "react-router-dom";
import { TranslateString } from "Utils/Common";
import { Link } from "react-router-dom";
import { message } from "antd";

const { Panel } = Collapse;

interface Import {
  name: string;
  address: string;
}

interface ErrorRow {
  csv_file_name: string;
  csv_row_number: number;
  error_description: string;
  error_type: string;
  date_time: string;
}
interface CountRow {
  filename: string;
  count: number;
  used_for: string;
}

const ImportLayout = (props: any) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [dataFor, setDataFor] = useState<any>(null);
  const [tableData, setTableData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [confirmLoadingBtn, setConfirmLoadingBtn] = useState(false);
  const [confirmValidLoadingBtn, setConfirmValidLoadingBtn] = useState(false);
  const [importGenerateAnalysis, setImportGenerateAnalysis] = useState<any>({});
  const [errorData, setErrorData] = useState<ErrorRow[]>([]);
  const [countData, setCountData] = useState<CountRow[]>([]);

  const columns: ITable<Import>["columns"] = [
    {
      dataIndex: "file_source_name",
      key: "file_source_name",
      title: TranslateString("Source System"),
      render: (category_id, row: any) => {
        return TranslateString(row?.file_source_name);
      },
    },
    // {
    //   dataIndex: "ktr_source_name",
    //   key: "ktr_source_name",
    //   title: TranslateString("Source System"),
    //   render: () => {
    //     return "Retta";
    //   },
    // },

    {
      dataIndex: "name",
      key: "name",
      title: TranslateString("File Name"),
      render: (category_id, row: any) => {
        return TranslateString(row?.name);
      },
    },
    {
      dataIndex: "used_for",
      key: "used_for",
      title: TranslateString("Used For"),
      render: (category_id, row: any) => {
        return TranslateString(row?.used_for);
      },
    },
    {
      dataIndex: "staging_row_count",
      key: "staging_row_count",
      title: TranslateString("count"),
      render: (category_id, row: any) => {
        // return row?.csv_row_count + "/" + row?.staging_row_count;
        return row?.staging_row_count + "/" + row?.csv_row_count;
      },
    },
    {
      dataIndex: "error_row_count",
      key: "error_row_count",
      title: TranslateString("Error Count"),
      render: (category_id, row: any) => {
        return row?.error_count;
      },
    },

    {
      dataIndex: "status",
      key: "status",
      title: TranslateString("Import Status"),
      className: "py-2",
      align: "center",
      render: (category_id, row: any) => {
        if (row?.mismatch_data === 1) {
          return (
            <Button
              type="primary"
              onClick={() => {
                navigate("/data-mismatch");
              }}
              className="border border-danger bg-white text-dark"
              disabled
            >
              {TranslateString("mismatch_data")}
            </Button>
          );
        } else {
          return (
            <span className="fw-bold text-success">
              {row?.data_load_status
                ? TranslateString(row?.data_load_status)
                : "-"}
            </span>
          );
        }
      },
    },

    {
      dataIndex: "last_modified_at",
      key: "last_modified_at",
      title: TranslateString("Last Import Done (Date and time)"),
    },

    // {
    //     dataIndex: 'category_id',
    //     key: 'category_id',
    //     title: TranslateString('Import'),
    //     align: 'center',
    //     render: (category_id, row: any) => {
    //         return (
    //             <button onClick={() => {
    //                 if (row?.count > 0) {
    //                     setOpen(true);
    //                     setDataFor(row);
    //                 } else {
    //                     setShow(!show);
    //                     setDataFor(row);
    //                 }
    //             }} disabled={row?.is_disabled == "1" ? true : false} className="btn btn-sm cu-btn-green py-0">{TranslateString('Import')}</button>
    //         );
    //     },
    // },
  ];

  // const errorColumns: ITable<ErrorRow>["columns"] = [
  //   {
  //     dataIndex: "csv_file_name",
  //     key: "csv_file_name",
  //     title: TranslateString("CSV File Name"),
  //     render: (category_id, row: any) => {
  //       return row?.csv_file_name;
  //     },
  //   },
  //   {
  //     dataIndex: "csv_row_number",
  //     key: "csv_row_number",
  //     align: "center" as const,
  //     title: TranslateString("CSV Row Number"),
  //     render: (category_id, row: any) => {
  //       return row?.csv_row_number;
  //     },
  //   },
  //   {
  //     dataIndex: "error_description",
  //     key: "error_description",
  //     title: TranslateString("Error Description"),
  //     render: (category_id, row: any) => {
  //       return row?.error_description;
  //     },
  //   },
  //      {
  //     dataIndex: "error_type",
  //     key: "error_type",
  //     title: TranslateString("Error Type"),
  //     render: (category_id, row: any) => {
  //       return row?.error_type;
  //     },
  //   },
  //   {
  //     dataIndex: "date_time",
  //     key: "date_time",
  //     title: TranslateString("Date And Time"),
  //     render: (category_id, row: any) => {
  //       return row?.logdate;
  //     },
  //   },
  // ];

   const columnss: ITable<CountRow>["columns"] = [
    
  
       {
      dataIndex: "filename",
      key: "filename",
      title: TranslateString("File Name"),
      render: (category_id, row: any) => {
        return row?.filename;
      },
    },
    {
      dataIndex: "used_for",
      key: "used_for",
      title: TranslateString("Used For"),
      render: (category_id, row: any) => {
        return TranslateString(row?.used_for);
      },
    },
    {
      dataIndex: "count",
      key: "count",
      title: TranslateString("Total Count"),
      render: (category_id, row: any) => {
        return row?.count ;
      },
    },
    
  ];

  const handleCancel = () => {
    setShow(false);
  };

  useEffect(() => {
    getAllImportList();
     getAllImportCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  function getAllImportList(): any {
    let object: any = {};
    setLoading(true);
    AdministrationImportServices.getAllImportList(object)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          setTableData(response?.data?.data);
          setImportGenerateAnalysis({
            analysis_done_count: response?.data?.analysis_done_count,
            analysis_total_count: response?.data?.analysis_total_count,
          });
          // Fetch error list after main import list
          // AdministrationImportServices.getAllImportErrorList({})
          //   .then((errorResponse: any) => {
          //     if (errorResponse?.data?.code === 200) {
          //       setErrorData(errorResponse?.data?.data || []);
          //     }
          //   })
          //   .catch((err: any) => {
          //     console.log("Error fetching import errors:", err);
          //   });
        }
        //
        
        setLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  }

  function getAllImportCount(): any {
  let object: any = {};
  setLoading(true);

  AdministrationImportServices.getAllImportCount(object)
    .then((response: any) => {
      if (response?.data?.code === 200) {
        setCountData(response?.data?.data || []);
      }

      setLoading(false);
    })
    .catch((err: any) => {
      console.log("Error fetching import count:", err);
      setLoading(false);
    });
}

  const handleOk = () => {
    setConfirmLoading(true);
    const object = {
      entity_type: dataFor?.entity_type,
    };
    AdministrationImportServices.deleteImportData(object)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          getAllImportList();
          setShow(!show);
          setConfirmLoading(false);
          setOpen(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setConfirmLoading(false);
      });
  };

  const handleCancelPop = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  const handleGenerateAnalysis = () => {
    setConfirmLoadingBtn(true);
    AdministrationImportServices.getGenerateAnalysis()
      .then((response: any) => {
        if (response?.data?.code === 200) {
          setConfirmLoadingBtn(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setConfirmLoadingBtn(false);
      });
  };

  const handleValidData = () => {
    setConfirmValidLoadingBtn(true);
    AdministrationImportServices.getValidateData()
      .then((response: any) => {
        if (response?.data?.code === 200) {
          setConfirmValidLoadingBtn(false);
          message.success(
            TranslateString("Validation process started successfully."),
          );
        }
      })
      .catch((err: any) => {
        console.log(err);
        setConfirmValidLoadingBtn(false);
      });
  };

  return (
    <>
      <AdminLayout>
        <Spin spinning={loading}>
          <div className="d-flex align-items-center justify-content-between mt-3 mb-4">
            <div className="d-flex align-items-center">
              <Link
                to="/housingcompany"
                className="d-flex align-items-center text-decoration-none"
              >
                <button className="ant-btn cu-border-0 back-btn text-primary me-3">
                  <FaArrowLeft style={{ fontWeight: 900, fontSize: "18px" }} />
                </button>
              </Link>

              <h4 className="fs-4 fw-medium text-secondary text-black mb-0">
                {TranslateString("Import Summary")}
              </h4>
            </div>

            <div className="text-end fw-normal text-secondary text-black">
              Loan Priority Calculated :{" "}
              {importGenerateAnalysis?.analysis_done_count || 0} / Total Loans :{" "}
              {importGenerateAnalysis?.analysis_total_count || 0}
              {/* <div className="d-flex justify-content-between mb-2">
              <div className="text-left fs-3"></div>
              <div className="text-right">
                (Priority Calculated : {importGenerateAnalysis?.analysis_done_count || 0} / Total Loans : {importGenerateAnalysis?.analysis_total_count || 0})
                Loan Priority Calculated :{" "}
                {importGenerateAnalysis?.analysis_done_count || 0} / Total Loans
                : {importGenerateAnalysis?.analysis_total_count || 0}
                &emsp;
                <button
                                    onClick={() => handleGenerateAnalysis()}
                                    className="btn btn-sm cu-btn-green"
                                    disabled={confirmLoadingBtn}
                                >
                                    {confirmLoadingBtn?TranslateString("Please Wait"):TranslateString('generate_analysis')}
                                </button>
                &emsp;
                <button
                                    onClick={() => handleValidData()}
                                    className="btn btn-sm cu-btn-green"
                                    disabled={confirmValidLoadingBtn}
                                >
                                    {confirmValidLoadingBtn?TranslateString("Please Wait"):TranslateString('validate_data')}
                                </button>
              </div>
            </div> */}
              {/* <div className="">
              <Table columns={columns} data={tableData} />
            </div> */}
            </div>
          </div>

          <div className="cu-table-small mb-4">
            <Table
              columns={columns}
              data={tableData}
              disablePagination
              rowClassName={(record: any) =>
                record?.error_count > 0 ? "error-row-red" : ""
              }
            />
          </div>

          {/* <Collapse
            expandIconPosition="left"
            className="professional-collapse"
            bordered={false}
          >
            <Panel
              header={
                <div className="d-flex align-items-center">
                  <span className="fs-4 fw-medium text-secondary text-black">
                    {TranslateString("Error Summary")}
                  </span>
                </div>
              }
              key="errors"
            >
              <div className="cu-table-small mt-3">
                <Table
                  columns={errorColumns}
                  data={errorData}
                  disablePagination
                />
              </div>
            </Panel>
          </Collapse> */}

          <Collapse
            expandIconPosition="left"
            className="professional-collapse"
            bordered={false}
          >
            <Panel
              header={
                <div className="d-flex align-items-center">
                  <span className="fs-4 fw-medium text-secondary text-black mb-0">
                    {TranslateString("Ador System Summary")}
                  </span>
                </div>
              }
              key="errors"
            >
              <div className="cu-table-small mt-3">
                 {/* <Table
              columns={columnss}
              data={tableData}
              disablePagination
              rowClassName={(record: any) =>
                record?.error_count > 0 ? "error-row-red" : ""
              }
            /> */}
             <Table
              columns={columnss}
              data={countData}
              disablePagination
              rowClassName={(record: any) =>
                record?.error_count > 0 ? "error-row-red" : ""
              }
            />
          
              </div>
            </Panel>
          </Collapse> 

        </Spin>
      </AdminLayout>
      <Modal
        destroyOnClose
        title={TranslateString("Import") + " : " + dataFor?.name || ""}
        className="bookingModal"
        open={show}
        footer={null}
        onCancel={handleCancel}
      >
        <FileUploader
          dataFor={dataFor?.entity_type}
          accept={".csv"}
          setModalShow={setShow}
          getAllImportListFunc={getAllImportList}
        />
      </Modal>
      <Modal
        title="Warning!"
        open={open}
        onOk={handleOk}
        okButtonProps={{ className: "cu-bg-green rounded" }}
        okText="Yes"
        cancelButtonProps={{ className: "cu-bg-green rounded" }}
        confirmLoading={confirmLoading}
        onCancel={handleCancelPop}
      >
        <p className="h5">
          {TranslateString(
            "you_already_have_data_in_this_analysis_do_you_want_to_fresh_upload",
          )}
        </p>
      </Modal>
    </>
  );
};
export default ImportLayout;
